import { render, staticRenderFns } from "./table-general-institution.vue?vue&type=template&id=5eba7a6f&scoped=true&"
import script from "./table-general-institution.vue?vue&type=script&lang=js&"
export * from "./table-general-institution.vue?vue&type=script&lang=js&"
import style0 from "./table-general-institution.vue?vue&type=style&index=0&id=5eba7a6f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eba7a6f",
  null
  
)

export default component.exports